import { render, staticRenderFns } from "./Especificas.vue?vue&type=template&id=0e9896b2&scoped=true"
import script from "./Especificas.vue?vue&type=script&lang=js"
export * from "./Especificas.vue?vue&type=script&lang=js"
import style0 from "./Especificas.vue?vue&type=style&index=0&id=0e9896b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9896b2",
  null
  
)

export default component.exports